module.exports = __webpack_public_path__ + "static/steps-dc5f8bdb1a0a4540520e3c1f796125ca.png";